<template>
  <div>
    <CCard class="custom-Quizcard h-100 mt-5" align="center">
      <CContainer>
      <CCol sm="12" class="justify-content-center">
        <br />
        <br />
        <br />
        <br />
        <br />
        <br />
        <Crow>
          <CCol class="col-sm-4 m-0"
            ><img src="../assets/img/SLpic.jpg" width="150px"
          />
          </CCol>
        </Crow>

        <div class="col-12">
          <div class="row">
            <div class="col-6">
              <h5 style="text-align: left" class="ml-2">Student List</h5>
            </div>
            <div class="col-6">
              <CButton color="success">
              <span
                @click="GoToPageRegisterStudent"
                > + Register New Student</span
              >
              </CButton>
            </div>
          </div>
        </div>

        <!-- <CCard class=" h-100 col-12  mb-4 " 
         v-for="item in StudentList"
         v-bind:key="item.Id"
          body-wrapper 
          text-color="dark"
          style= "border-radius:25px; background-color: ; box-shadow: 5px 5px 2px grey; border: 1px solid #090934;" -->

        <CCol
          v-for="(item, index) in StudentList"
          v-bind:key="item.Id"
          class="justify-content-center"
        >
          <br />
          <CRow
            id="sb"
            sm="12"
            lg="12"
            style="
              border-radius: 10px;
              border: 1px solid #009688;
              background: #ebedef;
            "
            class="m-0 pt-1 col-12 box-shadow"
            @click="GoStudentDashbboard(item.studentId)"
          >
            <CCol class="col-3 pt-2 pb-2">
              <span v-if="item.studentProfilePhoto != null">
                <img
                  :src="getPic(index)"
                  width="50px"
                  height="50px"
                  class="box-shadow"
                  style="border-radius: 50%; border: 1px solid #eee"
                />
              </span>
              <span v-else>
                <img
                  src="../assets/img/user.png"
                  width="50px"
                  height="50px"
                  class="box-shadow"
                  style="border-radius: 50%; border: 1px solid #eee"
                />
              </span>
            </CCol>
            <CCol class="col-9 text-left mt-3">
              <h6 class="ml-2 mr-2 text-black custom-font">
                {{ item.studentName }}
              </h6>
              <p class="ml-2 text-black custom-font small">
                {{ item.gradeName }}
              </p>
            </CCol>
          </CRow>
        </CCol>
        <!-- </CCard> -->
      </CCol>
      </CContainer>
      <br /><br />
    </CCard>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        height: 180px;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
    >
      <div style="width: 100%" class="mt-4">
        <CCol sm="12">
        <div class="image" align="center">
          <img src="../assets/img/Logo.png" width="50 px" height="50 px" />
             <!-- <p @click="GoToHome()" class="float-right">Go to Home</p> -->
        </div>
        </CCol>
        <br />
        <br />
        <h3 class="text-center m-0" style="color: Orange">
          Hi, {{ ParentProfile.userName }}
        </h3>
        <CCol sm="12">
          <span class="mt-5 mb-5"> </span>
          <br /><br /><br /><br />
        </CCol>
      </div>
    </div>
  </div>
</template>


<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/backgroundTutor.png";
import backgroundBanner from "../assets/img/bgApps.jpg";
import _ from "lodash";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-timepicker", VueTimepicker);
Vue.component("v-select", vSelect);
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
import VueTimepicker from "vue2-timepicker";
import "vue2-timepicker/dist/VueTimepicker.css";
import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";
//import Mainlayout from "../containers/TheHeaderStudentCustom.vue";

Vue.use(VuejsDialog);

export default {
  name: "Login",

  components: {
    PulseLoader,
    //Mainlayout
  },
  data() {
    return {
      backgroundBanner,
      StudentList: [],
      Error: false,
      SubmittedForm: false,
      ParentProfile: {},
    };
  },

  async mounted() {
    this.GetStudentDetails();
    this.GetParentProfile();
  },

  computed: {},
  methods: {
    async GetStudentDetails(index) {
      this.$API
        .get(
          this.$StudentList +
            "?userId=" +
            this.$route.query.userId +
            "&studentId=" +
            this.$route.query.studentId,
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.StudentList = response.data;
            this.getPic(this.StudentList.studentProfilePhoto);
            console.log(this.StudentList);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },
    getPic(index) {
      return (
        "https://pickiddo.com" + this.StudentList[index].studentProfilePhoto
      );
    },

    async GetParentProfile() {
      this.$API
        .get(this.$ParentProfile + "?userId=" + this.$route.query.userId, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.ParentProfile = response.data;
            console.log(this.ParentProfile);
          }
        })
        .catch(function (error) {
          console.log(error.response);
        });
    },

    GoStudentDashbboard(studentId) {
      this.$router.push(
        "/QuizStudentDashboard?userId=" +
          this.$route.query.userId +
          "&studentId=" +
          studentId
      );
    },
       GoToPageRegisterStudent() {
      this.$router.push("/RegisterStudent?userID=" + this.$route.query.userId);
    },

     GoToHome() {
      this.$router.push("/student/Mainpage?userId=" + this.$route.query.userId);
    },
  },
};
</script>
